import script from "./TicketsHistoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsHistoryList.vue?vue&type=script&setup=true&lang=js"

import "./TicketsHistoryList.vue?vue&type=style&index=0&id=b6fc9130&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6fc9130"]])

export default __exports__